import { styled } from "@mui/material";

import {
    Button,
    Grid,
    IconButton,
    Menu, MenuItem,
    Theme,
    Typography,
    useTheme,
    TextField,
    InputAdornment
} from "@mui/material";

import { IArquivo } from "../../types/arquivo";
import Arquivo from "./Arquivo";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import React, { useEffect, useState, useCallback } from 'react';
import { useLogin } from "../../contexts/LoginContext";
import { apiServer } from "../../api";

type CriterioOrdenacao = 'nome' | 'modificacao' | 'aberto';
type DirecaoOrdenacao = 'asc' | 'desc';

interface IMenuOrdenacaoProps {
    criterio: CriterioOrdenacao;
    onCriterioChange: (criterio: CriterioOrdenacao) => void;
}

const MenuOrdenacao = ({ criterio, onCriterioChange }: IMenuOrdenacaoProps) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (novoCriterio: CriterioOrdenacao) => {
        onCriterioChange(novoCriterio);
        handleClose();
    };

    const obterTextoCriterio = (c: CriterioOrdenacao) => {
        switch (c) {
            case 'nome': return 'Nome';
            case 'modificacao': return 'Última modificação';
            case 'aberto': return 'Última vez aberto';
            default: return 'Última modificação';
        }
    };

    return (
        <div>
            <Button sx={{ textTransform: 'none' }}
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                {obterTextoCriterio(criterio)}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => handleSelect('nome')}>Nome</MenuItem>
                <MenuItem onClick={() => handleSelect('modificacao')}>Última modificação</MenuItem>
                <MenuItem onClick={() => handleSelect('aberto')}>Última vez aberto</MenuItem>
            </Menu>
        </div>
    );
}

const Arquivos = () => {
    const theme: Theme = useTheme();

    const BFArquivos = styled('div')({});

    const BFCabecalhoArquivo = styled('div')({
        display: 'flex',
        flexDirection: 'row',
        alignSelf: 'flex-start'
    });

    const BFTituloCabecalho = styled(Typography)({
        fontSize: '0.95em',
        fontWeight: '500',
        marginTop: '5.5pt',
        marginLeft: '8pt',
        color: theme.palette.primary.main
    });

    const BFTipoOrdenacao = styled(IconButton)({

    })

    const BFEspacoCabecalho = styled('div')({
        flexGrow: '1'
    })

    const [login] = useLogin();
    const [arquivos, setArquivos] = useState<IArquivo[]>([]);
    const [criterio, setCriterio] = useState<CriterioOrdenacao>('modificacao');
    const [direcao, setDirecao] = useState<DirecaoOrdenacao>('desc');
    const [filtroTexto, setFiltroTexto] = useState<string>('');
    const [filtroData, setFiltroData] = useState<string>('');

    const carregarArquivosRecentes = useCallback(() => {
        const clienteID = login.usuario?.usuarioCliente?.clienteID;
        if (!clienteID || !login.accessToken)
            return;

        apiServer<IArquivo[]>()
            .get(`/arquivo/recentes/${clienteID}/32`, login.accessToken)
            .then((response) => {
                setArquivos(response.data);
            })
            .catch(() => {});
    }, [login.accessToken, login.usuario?.usuarioCliente?.clienteID]);

    useEffect(() => {
        carregarArquivosRecentes();
    }, [carregarArquivosRecentes]);

    const alternarDirecao = () => {
        setDirecao(prev => prev === 'desc' ? 'asc' : 'desc');
    };

    const obterArquivosFiltradosEOrdenados = () => {
        let temp = [...arquivos];

        // 1. Filtrar por texto no nome/descricao
        if (filtroTexto.trim() !== '') {
            const busca = filtroTexto.toLowerCase();
            temp = temp.filter(arq => {
                const nome = (arq.descricao || arq.nome || '').toLowerCase();
                return nome.includes(busca);
            });
        }

        // 2. Filtrar por data local
        if (filtroData !== '') {
            temp = temp.filter(arq => {
                if (!arq.dataUltimaModificacao) return false;
                const d = new Date(arq.dataUltimaModificacao);
                const ano = d.getFullYear();
                const mes = String(d.getMonth() + 1).padStart(2, '0');
                const dia = String(d.getDate()).padStart(2, '0');
                const dataArqStr = `${ano}-${mes}-${dia}`;
                return dataArqStr === filtroData;
            });
        }

        // 3. Ordenar
        temp.sort((a, b) => {
            let valA: any;
            let valB: any;

            if (criterio === 'nome') {
                valA = (a.descricao || a.nome || '').toLowerCase();
                valB = (b.descricao || b.nome || '').toLowerCase();
            } else if (criterio === 'modificacao') {
                valA = a.dataUltimaModificacao ? new Date(a.dataUltimaModificacao).getTime() : 0;
                valB = b.dataUltimaModificacao ? new Date(b.dataUltimaModificacao).getTime() : 0;
            } else if (criterio === 'aberto') {
                const aData = (a as any).dataCadastro || a.dataUltimaModificacao || 0;
                const bData = (b as any).dataCadastro || b.dataUltimaModificacao || 0;
                valA = aData ? new Date(aData).getTime() : 0;
                valB = bData ? new Date(bData).getTime() : 0;
            }

            if (valA < valB) return direcao === 'asc' ? -1 : 1;
            if (valA > valB) return direcao === 'asc' ? 1 : -1;
            return 0;
        });

        return temp;
    };

    return <BFArquivos>

        <BFCabecalhoArquivo>
            <BFTituloCabecalho variant="body1">Arquivos Recentes</BFTituloCabecalho>

            <BFEspacoCabecalho />

            <MenuOrdenacao criterio={criterio} onCriterioChange={setCriterio} />

            <BFTipoOrdenacao size="small" onClick={alternarDirecao}>
                {direcao === 'desc' ? (
                    <ArrowDownwardIcon fontSize="small" />
                ) : (
                    <ArrowUpwardIcon fontSize="small" />
                )}
            </BFTipoOrdenacao>

        </BFCabecalhoArquivo>

        {/* Barra de Filtros */}
        <Grid container spacing={2} sx={{ mb: 3, mt: 1, px: 1 }}>
            <Grid item xs={12} sm={7} md={8}>
                <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    placeholder="Pesquisar por nome do arquivo..."
                    value={filtroTexto}
                    onChange={(e) => setFiltroTexto(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon color="action" fontSize="small" />
                            </InputAdornment>
                        ),
                        endAdornment: filtroTexto && (
                            <InputAdornment position="end">
                                <IconButton size="small" onClick={() => setFiltroTexto('')}>
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={5} md={4}>
                <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    type="date"
                    label="Data de modificação"
                    InputLabelProps={{ shrink: true }}
                    value={filtroData}
                    onChange={(e) => setFiltroData(e.target.value)}
                    InputProps={{
                        endAdornment: filtroData && (
                            <InputAdornment position="end">
                                <IconButton size="small" onClick={() => setFiltroData('')}>
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>
        </Grid>

        <Grid container
            direction="row"
            justifyContent="left">

            {obterArquivosFiltradosEOrdenados().map((arquivo: IArquivo, i) => (
                <Grid key={i}
                    item
                    xs={12}
                    md={6}
                    lg={4}>
                    <Arquivo key={i} {...arquivo} />
                </Grid>
            ))}
        </Grid>
    </BFArquivos>
}

export default Arquivos;